import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import CanvasExpandedView from '../view/CanvasExpandedView';
import CanvasDefinitionTabState from './CanvasDefinitionTabState';

export default class CanvasDefinitionTabView extends BufferTabView<CanvasDefinitionTabState> {
  override initialize(): void {
    this.listenTo(this.model, 'change:versionApiId', () => this.render());
  }

  override render(): this {
    const canvasDefinitionId = this.model.get('canvasDefinitionId');
    const canvasVersionId = this.model.get('versionApiId');
    renderToDOM(
      <CanvasExpandedView
        canvasDefinitionId={canvasDefinitionId}
        canvasVersionId={canvasVersionId}
        key={canvasVersionId}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<CanvasDefinitionTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

CanvasDefinitionTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
